import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slices/authSlice";
import clientReducer from "./slices/clientSlice";
import projectReducer from "./slices/projectSlice";
import userReducer from "./slices/userSlice";
import timeEntriesReducer from "./slices/timeEntriesSlice";
import projectTrackingReducer from "./slices/projectTrackingSlice";
import timerReducer from "./slices/timerSlice";
import timeEntryReducer from "./slices/timeEntrySlice";
import quickbookConnectReducer from "./slices/quickbookConnectSlice";
import emailReducer from "./slices/emailSlice";
import clientOrganizationReducer from "./slices/clientOrganizationSlice";

// Configure timer persistence
const timerPersistConfig = {
  key: "timer",
  storage,
  whitelist: [
    "isActive",
    "startTime",
    "activeEntry",
    "elapsedTime",
    "lastUpdated",
  ],
};

// Configure time entry persistence
const timeEntryPersistConfig = {
  key: "timeEntry",
  storage,
  whitelist: ["teamMemberId", "projectId", "selectedProject"],
};

// Configure quickbookConnect persistence
const quickbookConnectPersistConfig = {
  key: "quickbookConnect",
  storage,
  whitelist: ["isConnected", "params", "accessToken", "refreshToken"],
};

// Define the app reducer with all individual reducers
const appReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  clients: clientReducer,
  projects: projectReducer,
  emails: emailReducer,
  timeEntries: timeEntriesReducer,
  projectTracking: projectTrackingReducer,
  timer: persistReducer(timerPersistConfig, timerReducer),
  timeEntry: persistReducer(timeEntryPersistConfig, timeEntryReducer),
  quickbookConnect: persistReducer(
    quickbookConnectPersistConfig,
    quickbookConnectReducer
  ),
  clientOrganization: clientOrganizationReducer,
});

// Root reducer that can handle the logout action to clear all state
const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};

export default rootReducer;
